"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectJourneyQuoteHeadingOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var DirectJourneyQuoteHeadingOutputWidget = /** @class */ (function (_super) {
    __extends(DirectJourneyQuoteHeadingOutputWidget, _super);
    function DirectJourneyQuoteHeadingOutputWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DirectJourneyQuoteHeadingOutputWidget.prototype.render = function () {
        var interaction = this.props.engine.getInteraction();
        var quoteRefNum = interaction._id;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "journey-questions-title", children: (0, jsx_runtime_1.jsx)("h1", { className: "quote-title", children: "Your home quote" }) }), (0, jsx_runtime_1.jsxs)("p", { children: ["Quote reference number: ", (0, jsx_runtime_1.jsx)("span", { className: "ref-num", children: quoteRefNum })] }), (0, jsx_runtime_1.jsx)("p", { className: "mb-0 font-weight-bold", children: "Please check your options below." }), (0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold pb-5", children: "With three levels of cover it\u2019s easy to select the one that you need." })] }));
    };
    return DirectJourneyQuoteHeadingOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.DirectJourneyQuoteHeadingOutputWidget = DirectJourneyQuoteHeadingOutputWidget;
//# sourceMappingURL=DirectJourneyQuoteHeadingOutputWidget.js.map